<template>
<!--	<qw-form @submit.prevent>-->
		<div v-if="editor"
			 ref="editorRoot"
			 class="editor show-on-print editor-view-root"
		:id="editorAffixTargetId"
		:class="{'input-background': isEditableComputed}">


			<BubbleMenu
				v-if="toolbarOptionsComputed.link"
				:options="bubbleMenuOptions"
				ref="bubbleMenu"
				pluginKey="linkBubbleMenu"
				:shouldShow="shouldShowLinkMenu"
				:editor="editor">
				<LinkEditBubbleMenu
					v-show="linkMenuIsActive"
					ref="linkBubble"
					:editor="editor"
					@hideMenu="hideLinkBubble"
					@change="showLinkMenu"/>
			</BubbleMenu>

			<div v-if="isEditableComputed" class="editor-toolbar-slot hide-on-print">
				<component
					:is="toolbarWrapperComponent"
					class="d-block"
					v-bind="toolbarWrapperProps"
					v-on="toolbarWrapperListeners"
				>
					<EditorFixedMenu
						@linkClicked="showLinkMenu"
						:editor="editor"
						:isAffixed="isToolbarAffixed"
						:toolbarOptions="toolbarOptionsComputed"/>
				</component>
			</div>


			<editor-content
				class="editor__content"
				:editor="editor"/>
			<hr v-if="isEditableComputed && (showDivider || showDividerOnHover)"
				style="padding-bottom: 10px;"
				:class="{'show-on-hover-item': showDividerOnHover, 'qw-border-primary': isFocusedData}"/>



		</div>
<!--	</qw-form>-->
</template>

<script>

import {Editor, EditorContent} from '@tiptap/vue-3'
import {BubbleMenu} from '@tiptap/vue-3/menus'
import StarterKit from "@tiptap/starter-kit"
import Placeholder from "@tiptap/extension-placeholder"
import Highlight from "@tiptap/extension-highlight"
import {Color, TextStyle} from "@tiptap/extension-text-style"
import LinkEditBubbleMenu from "@/core/modules/Notes/view/LinkEditBubbleMenu.vue";

import EditorFixedMenu from "@/core/modules/Notes/view/EditorFixedMenu.vue";
import {createDialogLazy} from "@/utils/helpers-external.js";
let EditorSetLinkDialog = () => import("@/core/modules/Notes/view/EditorSetLinkDialog.vue");
import LinkEx from "@/core/modules/Notes/view/LinkEx.js";
import BaseVModelView from "@/core/components/BaseVModelView.vue";
import {uuidv4} from "@/utils/helpers";

let editorSetLinkDialog = createDialogLazy(EditorSetLinkDialog)
const DEFAULT_TOOLBAR_OPTIONS = Object.freeze({
	bold: true,
	italic: true,
	strike: true,
	underline: true,
	heading1: true,
	heading2: true,
	heading3: true,
	bulletList: true,
	orderedList: true,
	blockquote: true,
	link: true,
	textColor: false,
	backgroundColor: false,
	undo: true,
	redo: true,
})

export default {
	name: "EditorView",
	extends: BaseVModelView,
	inheritAttrs: false,

	components: {
		EditorFixedMenu,
		LinkEditBubbleMenu,
		EditorContent,
		BubbleMenu,
		EditorSetLinkDialog,
	},
	props: {
		isEditable: {type: Boolean, default: true}, //legacy field. use readonly instead
		readonly: {type: Boolean, default: false},
		showDivider: {Boolean, default: true},
		showDividerOnHover: {Boolean, default: false},
		placeholder: {String, default: "type here"},
		toolbarOptions: {type: Object, default: () => ({})},
	},


	watch: {
		modelValue: {
			immediate: true,
			handler(newVal, oldVal) {
				//WARNING don't do this. below replaceAll("\n", "<br/>") breaks data consistency and while it may display correctly, the internal "\n" still there and if no changes are made to the content it will lead to inconsistent presentation upstream.
				// this.value = (newVal||"").replaceAll("\n", "<br/>")
				console.log("EditorView: modelValue = ", newVal)
				this.editorChangeExternally = true
				if (this.editor && !this.editorChange) {
					// console.log("EditorView: setContent")
					this.editor.commands.setContent(newVal, {emitUpdate: false})
					this.$forceUpdate()
					this.scheduleToolbarAffixModeUpdate()
				}
				this.editorChangeExternally = false
				this.editorChange = false;
			},
		},
		isEditableComputed(newVal) {
			if (this.editor) {
				this.editor.setEditable(newVal)
			}
		},
	},

	data() {
		return {
			isFocusedData: false,
			isToolbarAffixed: false,
			editorHeightPx: 0,
			linkUrl: null,
			linkMenuIsActive: false,
			editor: null,
			editorChange: false,
			editorChangeExternally: false,
			editorAffixTargetId: "",
			forceHideBubbleMenu: false,
			toolbarAffixMinHeightPx: 260,
		}
	},
	computed: {
		editorAffixTarget() {
			return `#${this.editorAffixTargetId}`
		},
		toolbarWrapperComponent() {
			if (this.shouldUseToolbarAffixComputed) {
				return "el-affix"
			}
			return "div"
		},
		toolbarWrapperProps() {
			if (this.shouldUseToolbarAffixComputed) {
				return {
					target: this.editorAffixTarget,
					offset: 0,
				}
			}
			return {}
		},
		toolbarWrapperListeners() {
			if (this.shouldUseToolbarAffixComputed) {
				return {
					change: this.onToolbarAffixChanged,
				}
			}
			return {}
		},
		shouldUseToolbarAffixComputed() {
			return this.editorHeightPx >= this.toolbarAffixMinHeightPx
		},
		isEditableComputed() {
			return this.isEditable && !this.readonly
		},
		toolbarOptionsComputed() {
			return {
				...DEFAULT_TOOLBAR_OPTIONS,
				...(this.toolbarOptions || {}),
			}
		},
		bubbleMenuOptions() {
			return {
				placement: 'top',
				strategy: 'absolute',
			}
		},
	},
	created() {
		this.editorAffixTargetId = `editor-view-affix-target-${uuidv4()}`
	},
	mounted() {

		console.log("this.isEditable = ", this.isEditable)
		console.log("this.value = " + this.value)

		this.editor = new Editor({
			enablePasteRules: false,
			enableInputRules: false,
			extensions: this.createEditorExtensions(),
			content: this.modelValue,
			onUpdate: this.onContentUpdate,
			editable: this.isEditableComputed,
			onFocus: this.onFocusEditor,
			onBlur: this.onBlurEditor,
			handleDoubleClick: this.handleDoubleClick,
			onTransaction: this.onTransaction,
		})
		console.log("this.editor = ", this.editor)
		this.scheduleToolbarAffixModeUpdate()
		window.addEventListener("resize", this.onWindowResize)

	},
	methods: {
		createEditorExtensions() {
			let extensions = [
				StarterKit.configure({
					link: false,
				}),
				LinkEx.configure({
					openOnClick: true,
					clickHandler: this.onLinkClicked.bind(this)
				}),
				TextStyle,
				Color,
				Highlight.configure({
					multicolor: true,
				}),
				Placeholder.configure({
					emptyEditorClass: 'is-editor-empty',
					emptyNodeClass: 'is-empty',
					placeholder: this.placeholder,
					showOnlyWhenEditable: true,
					showOnlyCurrent: true,
				}),
			]
			return extensions
		},

		insertTextAtCursor(text){
			console.log("EditorView: insertTextAtCursor")
			const transaction = this.editor.state.tr.insertText(text)
			this.editor.view.dispatch(transaction)
		},

		getCursorPosition(){
			return this.editor.state.selection.$anchor.pos
		},
		onTransaction({ state }) {
			setTimeout(() => {
				console.log("state.selection =", this.editor.state.selection)
				if(!this.editor.isActive("link")){
					this.linkMenuIsActive = false
				} else {
					if(this.$refs.linkBubble){
						this.$refs.linkBubble.refreshLink()
					}
				}
			})
		},

		handleDoubleClick(){
			console.log("handleDoubleClick")
		},

		onFocusEditor() {
			this.isFocusedData = true
			this.$emit('focus')

		},
		onBlurEditor() {
			this.isFocusedData = false
			// this.linkMenuIsActive = false //don't remove it here, because this will prevent link popup clicks.
			this.$emit('blur')
			this.onBlur()
		},

		onContentUpdate(content) {

			console.log("onContentUpdate1: ", content)
			if(this.editorChangeExternally){
				return
			}
			this.editorChange = true;
			this.valueData = content.editor.getHTML()
			this.notifyValueChanged()
			this.scheduleToolbarAffixModeUpdate()
		},
		onWindowResize() {
			this.scheduleToolbarAffixModeUpdate()
		},
		scheduleToolbarAffixModeUpdate() {
			requestAnimationFrame(() => {
				this.updateToolbarAffixMode()
			})
		},
		updateToolbarAffixMode() {
			let editorRootElement = this.$refs.editorRoot
			if (!editorRootElement) {
				return
			}
			this.editorHeightPx = editorRootElement.offsetHeight
			if (!this.shouldUseToolbarAffixComputed) {
				this.isToolbarAffixed = false
			}
		},

		shouldShowLinkMenu({ editor, view, state, oldState, from, to }) {
			// only show the bubble menu for images and links
			let res = editor.isActive('link')
			console.log("BubbleMenu: shouldShow = ", res, ", editor = ", editor)
			return true// && !this.forceHideBubbleMenu
		},

		hideLinkBubble(){
			this.linkMenuIsActive = false
		},
		onToolbarAffixChanged(isAffixed) {
			this.isToolbarAffixed = isAffixed
		},


		onLinkClicked(link) {
			console.log("onLinkClicked = ", link)
			if(this.isEditableComputed){
				this.linkUrl = link
				this.linkMenuIsActive = true
			} else {
				window.open(link, "_blank")
			}
		},

		async showLinkMenu() {
			console.log("EditorView.showLinkMenu")
			this.hideLinkBubble()
			await editorSetLinkDialog({
				editor: this.editor,
			})

		},
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.onWindowResize)
		this.editor.destroy()
	},
}
</script>
<style lang="scss">
@import "editor";

.editor-view-root{
	p {
		margin: 0;
	}
}
.editor p.is-editor-empty:first-child::before {
	content: attr(data-placeholder);
	float: left;
	color: #aaa;
	pointer-events: none;
	height: 0;
}

//.editor p.is-editor-empty:first-child::before {
//	content: attr(data-placeholder);
//	float: left;
//	color: #adb5bd;
//	pointer-events: none;
//	height: 0;
//}
</style>
